import QRCode from 'qrcode';

export async function getQrSvg(url: string) {
  return QRCode.toString(url, {
    type: 'svg',
    margin: 1,
    color: {
      dark: '#101626',
      light: '#FFFFFF'
    },
    width: 220
  });
}
